import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pageNames = {
  '/': 'Home', '/home': 'Home', '/leaderboard': 'Leaderboard',
  '/rewards': 'Wager Rewards', '/vip-rewards': 'VIP Rewards', '/originals': 'Originals',
  '/games/keno': 'Keno', '/games/blackjack': 'Blackjack', '/games/mines': 'Mines',
  '/games/limbo': 'Limbo', '/games/dice': 'Dice', '/games/plinko': 'Plinko',
  '/account': 'My Profile', '/account/bets': 'My Bets', '/settings': 'Settings',
};
const adminNames = { users: 'Users', games: 'Originals', wager: 'Wager Competition', youtube: 'YouTube Channels', site: 'Site Settings' };
const siteTabNames = { settings: 'Site Settings', users: 'Users', tipping: 'Tipping', alerts: 'Alerts', bets: 'Bet Logs', audit: 'Audit Logs' };

export const BrowserMetadata = ({ underConstruction = false }) => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const path = pathname.toLowerCase().replace(/\/+$/, '') || '/';
    let name = pageNames[path];
    if (path === '/admin') {
      const params = new URLSearchParams(search);
      const section = params.get('section');
      let detail = section === 'site' ? siteTabNames[params.get('tab')] || adminNames.site : adminNames[section];
      if (section === 'site' && params.get('tab') === 'tipping' && params.get('view') === 'credits') detail = 'Promotional Credits';
      name = detail ? `Admin · ${detail}` : 'Admin';
    } else if (/^\/bet\/[^/]+$/.test(path)) name = 'Bet Details';
    if (underConstruction) name = 'Under Construction';
    document.title = name ? `GVRewards · ${name}` : 'GVRewards';
  }, [pathname, search, underConstruction]);
  return null;
};